import { useState } from 'react'
import Main from '../../../component/Main';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect';
import SearchBtn from '../../../component/common/button/SearchBtn';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid';

const BdTrcdDiagList = () => {

    const [searchParams, setSearchParams] = useState({
        searchGrdc: '',
        searchLoca: '',
        searchEmog: '',
        searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchGubun: 'trpt',
        searchCheck1: '',
        searchCheck2: '',
        validationCheckList: ['searchEmog']
    });

    const searchParamsAdditional = {
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        if (name === 'searchGubun') {
            setState(prev => ({
                ...prev,
                dataList: []
            }));
        }
        setSearchParams(newParams);
    };

    let gridInfo = {
        'trpt': {
            dataHead: ['번호', '병원명', '내원일자', '내원시간', '등록번호', '코드', '내용'],
            dataColumn: ['SEQ', 'EMOGDESC', 'TRPTINDT', 'TRPTINTM', 'TRPTIDNO', 'TRPTTRCD', 'TRCDDESC'],
            excelFileName: '응급실내_검사_처치_수술',
        },
        'dgot': {
            dataHead: ['번호', '병원명', '내원일자', '내원시간', '등록번호', '코드', '일련번호', '내용', '진단구분'],
            dataColumn: ['SEQ', 'EMOGDESC', 'DGOTINDT', 'DGOTINTM', 'DGOTIDNO', 'DGOTDIAG', 'DGOTSERL', 'DIAGDESC', 'DGOTDGGB'],
            excelFileName: '응급실_퇴실진단',
        },
        'oppt': {
            dataHead: ['번호', '병원명', '내원일자', '내원시간', '등록번호', '코드', '내용'],
            dataColumn: ['SEQ', 'EMOGDESC', 'OPPTINDT', 'OPPTINTM', 'OPPTIDNO', 'OPPTOPCD', 'TRCDDESC'],
            excelFileName: '입원후_검사_처치_수술',
        },
        'dgdc': {
            dataHead: ['번호', '병원명', '내원일자', '내원시간', '등록번호', '코드', '일련번호', '내용', '진단구분'],
            dataColumn: ['SEQ', 'EMOGDESC', 'DGDCINDT', 'DGDCINTM', 'DGDCIDNO', 'DGDCDIAG', 'DGDCSERL', 'DIAGDESC', 'DGDCDGGB'],
            excelFileName: '입원후_퇴원진단',
        }
    };

    let {
        dataHead = [],
        dataColumn = [],
        apiCall = '/ptmiapi/jinryo/selectTrcddiagList.do',
        apiCntCall = '/ptmiapi/jinryo/selectTrcddiagListCnt.do',
        excelFileName = '',
        excelHead = []
    } = gridInfo[searchParams.searchGubun] || {};

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: true,
        currentPage: 1,
        itemsPerPage: 50,
        totalItems: 0
    });

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="9%" />
                        <col width="24%" />
                        <col width="8%" />
                        <col width="20%" />
                        <col width="9%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                        </tr>
                        <tr>
                            <th>내원일시</th>
                            <td>
                                <input
                                    type="date"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                />
                                &nbsp;~&nbsp;
                                <input
                                    type="date"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                />
                            </td>
                            <th>구분</th>
                            <td>
                                <select
                                    id="searchGubun"
                                    name="searchGubun"
                                    className='w-full'
                                    onChange={handleInputChange}>
                                    <option value="trpt">응급실내 검사, 처치, 수술</option>
                                    <option value="dgot">응급실 퇴실진단</option>
                                    <option value="oppt">입원후 검사, 처치, 수술</option>
                                    <option value="dgdc">입원후 퇴원진단</option>
                                </select>
                            </td>
                            <th>코드범위</th>
                            <td style={{ paddingRight: '0' }}>
                                <input
                                    type="text"
                                    id="searchCheck1"
                                    name="searchCheck1"
                                    value={searchParams.searchCheck1}
                                    onChange={handleInputChange}
                                    style={{ width: '47%' }}
                                    className='h-7'
                                />
                                &nbsp;~&nbsp;
                                <input
                                    type="text"
                                    id="searchCheck2"
                                    name="searchCheck2"
                                    value={searchParams.searchCheck2}
                                    onChange={handleInputChange}
                                    style={{ width: '47%' }}
                                    className='h-7'
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
        </Main>
    )
}

export default BdTrcdDiagList